import type { RTFormData } from "app/pages/activation/components/RankWidget/types";
import type { RTCampaignCreationDTO } from "app/pages/activation/types/api";
import { DEVICES_TYPES_FOR_API } from "app/UtilitiesAndConstants/Constants/DevicesTypes";

export const prepareCreationData = (formData: RTFormData): RTCampaignCreationDTO => {
    const devices =
        formData.source === DEVICES_TYPES_FOR_API.COMBINED
            ? [DEVICES_TYPES_FOR_API.DESKTOP, DEVICES_TYPES_FOR_API.MOBILE]
            : [formData.source];

    return {
        campaignName: formData.name,
        country: formData.country,
        competitors: formData.competitors,
        devices,
    };
};
